import { render } from "./BrowserViewerPresentationListItem.vue?vue&type=template&id=c2eef0e2"
import script from "./BrowserViewerPresentationListItem.vue?vue&type=script&lang=js"
export * from "./BrowserViewerPresentationListItem.vue?vue&type=script&lang=js"

import "./BrowserViewerPresentationListItem.vue?vue&type=style&index=0&id=c2eef0e2&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__